// src/mock/mockData.js

import { parseLocalDate } from '../shared/utils/dateUtils';

// Seed for reproducible "random" data
const seededRandom = (seed) => {
    const x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
};

// Base users
export const mockUsers = [
    { username: 'e830341c-7818-4f5f-9d02-85f65f3e6c9a', email: 'magnus@example.com', firstName: 'Magnus', lastName: 'Nielsen', profilePicture: 'https://i.pravatar.cc/150?img=1' },
    { username: 'd0dd960e-4bef-4cb6-a41a-2819afe6fb35', email: 'abel@example.com', firstName: 'Abel', lastName: 'Klein', profilePicture: 'https://i.pravatar.cc/150?img=2' },
    { username: 'c258b71c-3817-4c07-a744-a5c12b13c256', email: 'oscar@example.com', firstName: 'Oscar', lastName: 'Blom', profilePicture: 'https://i.pravatar.cc/150?img=3' },
    { username: 'a1b2c3d4-1234-5678-9abc-def012345678', email: 'emma@example.com', firstName: 'Emma', lastName: 'Andersen', profilePicture: 'https://i.pravatar.cc/150?img=4' },
    { username: 'b2c3d4e5-2345-6789-abcd-ef0123456789', email: 'lucas@example.com', firstName: 'Lucas', lastName: 'Pedersen', profilePicture: 'https://i.pravatar.cc/150?img=5' },
    { username: 'c3d4e5f6-3456-789a-bcde-f01234567890', email: 'sofia@example.com', firstName: 'Sofia', lastName: 'Jensen', profilePicture: 'https://i.pravatar.cc/150?img=6' },
    { username: 'd4e5f6a7-4567-89ab-cdef-012345678901', email: 'oliver@example.com', firstName: 'Oliver', lastName: 'Hansen', profilePicture: 'https://i.pravatar.cc/150?img=7' },
    { username: 'e5f6a7b8-5678-9abc-def0-123456789012', email: 'ida@example.com', firstName: 'Ida', lastName: 'Larsen', profilePicture: 'https://i.pravatar.cc/150?img=8' },
    { username: 'f6a7b8c9-6789-abcd-ef01-234567890123', email: 'noah@example.com', firstName: 'Noah', lastName: 'Christensen', profilePicture: 'https://i.pravatar.cc/150?img=9' },
    { username: 'a7b8c9d0-789a-bcde-f012-345678901234', email: 'mia@example.com', firstName: 'Mia', lastName: 'Mortensen', profilePicture: 'https://i.pravatar.cc/150?img=10' },
    { username: 'b8c9d0e1-89ab-cdef-0123-456789012345', email: 'elijah@example.com', firstName: 'Elijah', lastName: 'Sørensen', profilePicture: 'https://i.pravatar.cc/150?img=11' },
    { username: 'c9d0e1f2-9abc-def0-1234-567890123456', email: 'amelia@example.com', firstName: 'Amelia', lastName: 'Thomsen', profilePicture: 'https://i.pravatar.cc/150?img=12' },
    { username: 'd0e1f2a3-abcd-ef01-2345-678901234567', email: 'liam@example.com', firstName: 'Liam', lastName: 'Kristensen', profilePicture: 'https://i.pravatar.cc/150?img=13' },
    { username: 'e1f2a3b4-cdef-0123-4567-890123456789', email: 'harper@example.com', firstName: 'Harper', lastName: 'Poulsen', profilePicture: 'https://i.pravatar.cc/150?img=14' },
    { username: 'f2a3b4c5-def0-1234-5678-901234567890', email: 'jackson@example.com', firstName: 'Jackson', lastName: 'Olsen', profilePicture: 'https://i.pravatar.cc/150?img=15' },
    { username: 'a3b4c5d6-ef01-2345-6789-012345678901', email: 'evelyn@example.com', firstName: 'Evelyn', lastName: 'Rasmussen', profilePicture: 'https://i.pravatar.cc/150?img=16' },
    { username: 'b4c5d6e7-f012-3456-7890-123456789012', email: 'aiden@example.com', firstName: 'Aiden', lastName: 'Jørgensen', profilePicture: 'https://i.pravatar.cc/150?img=17' },
    { username: 'c5d6e7f8-0123-4567-8901-234567890123', email: 'scarlett@example.com', firstName: 'Scarlett', lastName: 'Frederiksen', profilePicture: 'https://i.pravatar.cc/150?img=18' },
    { username: 'd6e7f8a9-1234-5678-9012-345678901234', email: 'ethan@example.com', firstName: 'Ethan', lastName: 'Johansen', profilePicture: 'https://i.pravatar.cc/150?img=19' },
    { username: 'e7f8a9b0-2345-6789-0123-456789012345', email: 'victoria@example.com', firstName: 'Victoria', lastName: 'Nielsen', profilePicture: 'https://i.pravatar.cc/150?img=20' },
    { username: 'f8a9b0c1-3456-7890-1234-567890123456', email: 'mason@example.com', firstName: 'Mason', lastName: 'Lund', profilePicture: 'https://i.pravatar.cc/150?img=21' },
    { username: 'a9b0c1d2-4567-8901-2345-678901234567', email: 'aria@example.com', firstName: 'Aria', lastName: 'Svensson', profilePicture: 'https://i.pravatar.cc/150?img=22' },
    { username: 'b0c1d2e3-5678-9012-3456-789012345678', email: 'logan@example.com', firstName: 'Logan', lastName: 'Eriksson', profilePicture: 'https://i.pravatar.cc/150?img=23' },
    { username: 'c1d2e3f4-6789-0123-4567-890123456789', email: 'chloe@example.com', firstName: 'Chloe', lastName: 'Andersson', profilePicture: 'https://i.pravatar.cc/150?img=24' },
    { username: 'd2e3f4a5-7890-1234-5678-901234567890', email: 'caleb@example.com', firstName: 'Caleb', lastName: 'Lindberg', profilePicture: 'https://i.pravatar.cc/150?img=25' },
    { username: 'e3f4a5b6-8901-2345-6789-012345678901', email: 'grace@example.com', firstName: 'Grace', lastName: 'Berg', profilePicture: 'https://i.pravatar.cc/150?img=26' },
    { username: 'f4a5b6c7-9012-3456-7890-123456789012', email: 'daniel@example.com', firstName: 'Daniel', lastName: 'Ström', profilePicture: 'https://i.pravatar.cc/150?img=27' },
    { username: 'a5b6c7d8-0123-4567-8901-234567890123', email: 'lily@example.com', firstName: 'Lily', lastName: 'Norberg', profilePicture: 'https://i.pravatar.cc/150?img=28' },
    { username: 'b6c7d8e9-1234-5678-9012-345678901234', email: 'samuel@example.com', firstName: 'Samuel', lastName: 'Wahlberg', profilePicture: 'https://i.pravatar.cc/150?img=29' },
    { username: 'c7d8e9f0-2345-6789-0123-456789012345', email: 'zoe@example.com', firstName: 'Zoe', lastName: 'Lindqvist', profilePicture: 'https://i.pravatar.cc/150?img=30' },
];

// Activity types with their characteristics
const activityTypes = [
    { type: 'running', minDistance: 2, maxDistance: 25, minElevation: 0, maxElevation: 500, minDuration: 600, maxDuration: 10800 },
    { type: 'cycling', minDistance: 10, maxDistance: 100, minElevation: 0, maxElevation: 1500, minDuration: 1200, maxDuration: 18000 },
    { type: 'swimming', minDistance: 0.5, maxDistance: 5, minElevation: 0, maxElevation: 0, minDuration: 600, maxDuration: 5400 },
    { type: 'hiking', minDistance: 5, maxDistance: 30, minElevation: 100, maxElevation: 2000, minDuration: 3600, maxDuration: 28800 },
    { type: 'walking', minDistance: 2, maxDistance: 15, minElevation: 0, maxElevation: 200, minDuration: 1200, maxDuration: 7200 }
];

// Helper function to calculate points based on activity type
export const calculatePoints = (activity) => {
    let points = 0;
    switch (activity.activityType) {
        case 'running':
            points = activity.distance + (activity.elevation / 100);
            break;
        case 'cycling':
            points = (activity.distance * 0.25) + (activity.elevation / 200);
            break;
        case 'swimming':
            points = activity.distance * 4;
            break;
        case 'hiking':
            points = (activity.distance * 0.5) + (activity.elevation / 100 * 0.5);
            break;
        case 'walking':
            points = (activity.distance * 0.3) + (activity.elevation / 150);
            break;
        default:
            points = activity.distance;
    }
    return Number(points.toFixed(2));
};

// Generate random number in range using seed
const randomInRange = (min, max, seed) => {
    return min + seededRandom(seed) * (max - min);
};

// Generate activities dynamically
const generateActivities = () => {
    const activities = [];
    const now = new Date();
    let activityId = 1;

    // Generate activities for the past 18 months
    for (let monthsAgo = 0; monthsAgo < 18; monthsAgo++) {
        // Each user gets 2-8 activities per month
        for (let userIndex = 0; userIndex < mockUsers.length; userIndex++) {
            const user = mockUsers[userIndex];
            const activitiesThisMonth = Math.floor(randomInRange(2, 9, userIndex * 100 + monthsAgo));

            for (let i = 0; i < activitiesThisMonth; i++) {
                const seed = activityId * 1000 + userIndex * 100 + monthsAgo * 10 + i;
                const activityTypeIndex = Math.floor(randomInRange(0, activityTypes.length, seed));
                const actType = activityTypes[activityTypeIndex];

                const distance = Number(randomInRange(actType.minDistance, actType.maxDistance, seed + 1).toFixed(2));
                const elevation = Math.floor(randomInRange(actType.minElevation, actType.maxElevation, seed + 2));
                const duration = Math.floor(randomInRange(actType.minDuration, actType.maxDuration, seed + 3));

                // Random day within the month
                const date = new Date(now);
                date.setMonth(date.getMonth() - monthsAgo);
                date.setDate(Math.floor(randomInRange(1, 28, seed + 4)));
                date.setHours(Math.floor(randomInRange(6, 20, seed + 5)), 0, 0, 0);

                const activity = {
                    activityId: String(activityId),
                    activityType: actType.type,
                    distance,
                    elevation,
                    date: date.toISOString(),
                    duration,
                    username: user.username,
                    points: 0
                };
                activity.points = calculatePoints(activity);

                // Add description to some activities
                if (seededRandom(seed + 6) > 0.7) {
                    const descriptions = [
                        'Great workout today!',
                        'Felt strong throughout',
                        'Recovery session',
                        'Pushed hard on the hills',
                        'Beautiful weather for this',
                        'Personal best attempt',
                        'Easy pace today',
                        'Group session with friends',
                        'Morning routine',
                        'Evening stress relief'
                    ];
                    activity.description = descriptions[Math.floor(randomInRange(0, descriptions.length, seed + 7))];
                }

                // Add calories to some activities
                if (seededRandom(seed + 8) > 0.3) {
                    activity.calories = Math.floor(activity.points * randomInRange(30, 50, seed + 9));
                }

                activities.push(activity);
                activityId++;
            }
        }
    }

    return activities.sort((a, b) => new Date(b.date) - new Date(a.date));
};

// Competition name templates
const competitionNames = [
    'Minister of Activity',
    'Spring Challenge',
    'Summer Showdown',
    'Fall Fitness Frenzy',
    'Winter Warriors',
    'New Year Resolution',
    'March Madness Fitness',
    'Holiday Hustle',
    'Quarterly Quest',
    'Monthly Motivation'
];

// Generate competitions dynamically
const generateCompetitions = (activities) => {
    const competitions = [];
    const now = new Date();
    let competitionId = 1;

    // Generate competitions for the past 12 months and 2 months into the future
    for (let monthOffset = -12; monthOffset <= 2; monthOffset++) {
        const seed = competitionId * 500 + monthOffset;

        // 1-2 competitions per month
        const competitionsThisMonth = monthOffset === 0 ? 2 : Math.floor(randomInRange(1, 3, seed));

        for (let i = 0; i < competitionsThisMonth; i++) {
            const compSeed = seed + i * 100;

            const startDate = new Date(now);
            startDate.setMonth(startDate.getMonth() + monthOffset);
            startDate.setDate(i === 0 ? 1 : 15);
            startDate.setHours(0, 0, 0, 0);

            // Competition duration: 2-6 weeks
            const durationWeeks = Math.floor(randomInRange(2, 7, compSeed));
            const endDate = new Date(startDate);
            endDate.setDate(endDate.getDate() + durationWeeks * 7);

            // Determine state based on dates
            let state;
            if (endDate < now) {
                state = 'concluded';
            } else if (startDate > now) {
                state = 'upcoming';
            } else {
                state = 'active';
            }

            // Select random competitors (3-8 users)
            const numCompetitors = Math.floor(randomInRange(3, Math.min(9, mockUsers.length + 1), compSeed + 1));
            const shuffledUsers = [...mockUsers].sort(() => seededRandom(compSeed + 2) - 0.5);
            const competitors = shuffledUsers.slice(0, numCompetitors).map(u => u.username);

            // Calculate points for each competitor in this competition
            const competitorPoints = competitors.map(username => {
                const userActivities = activities.filter(a =>
                    a.username === username &&
                    new Date(a.date) >= startDate &&
                    new Date(a.date) <= endDate
                );
                return {
                    username,
                    totalPoints: userActivities.reduce((sum, act) => sum + act.points, 0)
                };
            }).sort((a, b) => b.totalPoints - a.totalPoints);

            // Minister is the top scorer
            const minister = competitorPoints[0] || { username: competitors[0], totalPoints: 0 };

            // Point target is based on average or set value
            const avgPoints = competitorPoints.reduce((sum, c) => sum + c.totalPoints, 0) / competitorPoints.length;
            const pointTarget = Number((avgPoints * randomInRange(0.6, 0.9, compSeed + 3)).toFixed(2)) || 25;

            const nameIndex = Math.floor(randomInRange(0, competitionNames.length, compSeed + 4));

            competitions.push({
                name: competitionNames[nameIndex],
                competitionId,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString(),
                state,
                ministerOfActivity: {
                    username: minister.username,
                    lastRoundPoints: Number(minister.totalPoints.toFixed(2))
                },
                competitors,
                pointTarget
            });

            competitionId++;
        }
    }

    return competitions.sort((a, b) => parseLocalDate(b.startDate) - parseLocalDate(a.startDate));
};

// Generate the mock data
export const mockActivities = generateActivities();
export const mockCompetitions = generateCompetitions(mockActivities);
